import type { TFunction } from "i18next";
import React, { type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Skeleton } from "src/components/Skeleton/Skeleton.tsx";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useEditTabsV2 } from "src/framework/layoutV2/useEditTabsV2.tsx";
import { observer } from "mobx-react-lite";
import { useModuleTabs } from "src/framework/layout/ModuleTabsProvider.tsx";

export const EditTabTitleV2 = observer(
  <Row extends Record<string, string> = Record<string, string>>({
    getTitle,
    getIdFromRow: getIdFromRowProp,
    id,
    idParam,
    resource,
    includes,
  }: {
    getTitle?: (resource: any, t: TFunction) => ReactNode;
    getIdFromRow?: (row: Row) => string;
    id: string;
    idParam: string;
    resource: string;
    includes?: string[];
  }) => {
    const { t } = useTranslation();

    const moduleTabsStore = useModuleTabs();

    const {
      isLoading,
      isFetching,
      data: listRes,
      error,
    } = useEditTabsV2({
      moduleTabsStore,
      resource,
      idParam,
      includes,
    });

    const getIdFromRow = (record: any) => {
      if (getIdFromRowProp) {
        return getIdFromRowProp(record);
      }
      return record.id;
    };

    const record = listRes?.data.find((record) => {
      // @ts-ignore
      return getIdFromRow(record) === id;
    });

    if (isLoading || (isFetching && !record)) {
      return <Skeleton isLoading={true}>{id}</Skeleton>;
    }

    if (error) {
      return t("unexpected-error", {
        ns: TranslationNamespaceEnum.Common,
      });
    }

    if (!record) {
      return t("not-found", {
        ns: TranslationNamespaceEnum.Common,
      });
    }

    return <>{getTitle?.(record, t)}</>;
  },
);
